import { render, staticRenderFns } from "./TabCommunity.vue?vue&type=template&id=64ab5b16&scoped=true&"
import script from "./TabCommunity.vue?vue&type=script&lang=js&"
export * from "./TabCommunity.vue?vue&type=script&lang=js&"
import style0 from "./TabCommunity.vue?vue&type=style&index=0&id=64ab5b16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ab5b16",
  null
  
)

export default component.exports